import React from 'react';
import { CustomerDataAddress, StyledH3 } from 'components';
import { AULink } from 'components/AULink';
import { ADDRESS_BOOK } from 'constants/navigation';
import { ActionLabel, HeaderWrapper } from './styled';
import { DefaultAddresses } from './DefaultAddresses';
import { useDispatch } from 'react-redux';
import { openAddressFormModal } from 'store/modal/actions';

export const AddressBook = ({ addresses }: { addresses: CustomerDataAddress[] }): JSX.Element => {
  const dispatch = useDispatch();

  const handleEditAddress = (address: CustomerDataAddress, modalTitle?: string) => {
    dispatch(openAddressFormModal({ address, modalTitle }));
  };

  return (
    <>
      <HeaderWrapper underlined>
        <StyledH3 secondary>Address Book</StyledH3>
        <ActionLabel>
          <AULink path={ADDRESS_BOOK.url} id="view-address-book">
            Manage Adresses
          </AULink>
        </ActionLabel>
      </HeaderWrapper>
      <DefaultAddresses addresses={addresses} handleEditAddress={handleEditAddress} />
    </>
  );
};
